import React from "react";
import PropTypes from "prop-types";
import { Button, Tooltip } from "@nextui-org/react";
import { ReactComponent as Cancel } from "../../../assets/icons/cancel-2.svg";
import { ReactComponent as Edit } from "../../../assets/icons/edit.svg";
import {
  stringToTicketStatus,
  TicketPhase,
  TicketStatus,
} from "../../../assets/js/AppTicketConstant";
import { actionsPropType } from "../../../models/ActionProp";

const DealerActionButtons = ({
  ticketPhase,
  ticketStatus,
  actions,
  data,
  actionType,
  claimData,
  reviewAction,
}) => {
  const handleAction = (actionFunc) => {
    if (typeof actionFunc === "function") {
      return () => actionFunc(data);
    }
    return undefined;
  };

  const submitClaimButton = ({ isDisabled }) => {
    return (
      <div className="flex flex-col" key={actionType}>
        <Button
          className={`font-medium !text-white text-nowrap ${
            isDisabled ? "bg-gray-400" : "bg-warning"
          }`}
          onPress={handleAction(actions?.submitPaymentProof?.onPress)}
          size="md"
          isDisabled={isDisabled}
        >
          ส่งหลักฐานการจ่ายเงิน
        </Button>
        {claimData && (
          <p className="pt-1 text-complete">แนบไฟล์หลักฐานสำเร็จแล้ว</p>
        )}
      </div>
    );
  };

  const editButton = ({ isDisabled }) => {
    return (
      <div className="flex flex-col items-center" key={actionType}>
        <Tooltip key="edit_button" content="Edit ticket">
          <Button
            isIconOnly
            variant="light"
            isDisabled={isDisabled}
            onPress={!isDisabled && handleAction(actions?.editable?.onPress)}
          >
            <Edit
              key="edit_button"
              className={isDisabled ? "svg-disable" : ""}
            />
          </Button>
        </Tooltip>
        {reviewAction === TicketStatus.Edit && (
          <p className="pt-1 text-complete text-nowrap">แก้ไขสำเร็จ</p>
        )}
      </div>
    );
  };

  const renderActionButton = () => {
    switch (ticketPhase) {
      case TicketPhase.Proposal:
        switch (ticketStatus) {
          case TicketStatus.AwaitingApproval:
            switch (actionType) {
              case "editable": {
                const isDisabled = data.status !== "REJECTED";
                return editButton({ isDisabled: isDisabled });
              }

              case "canceled": {
                return (
                  <Tooltip
                    key="cancel_button"
                    color="danger"
                    content="Cancel ticket"
                  >
                    <div
                      className="cursor-pointer"
                      onClick={handleAction(actions?.cancelled?.onPress)}
                    >
                      <Cancel />
                    </div>
                  </Tooltip>
                );
              }

              default:
                return null;
            }

          case TicketStatus.Approved:
            switch (actionType) {
              case "submitPaymentProof":
                return submitClaimButton({
                  isDisabled: ticketStatus === TicketStatus.AwaitingApproval,
                });
              default:
                return null;
            }

          case TicketStatus.Rejected:
            switch (actionType) {
              case "editable":
                return editButton({
                  isDisabled:
                    stringToTicketStatus(data.status.data) !==
                    TicketStatus.Rejected,
                });
              default:
                return null;
            }

          default:
            return null;
        }

      case TicketPhase.Claim:
        switch (ticketStatus) {
          case TicketStatus.Rejected:
            switch (actionType) {
              case "editable": {
                const isDisabled =
                  stringToTicketStatus(data.status.data) !==
                  TicketStatus.Rejected;
                return editButton({ isDisabled: isDisabled });
              }
              default:
                return null;
            }
          default:
            switch (actionType) {
              case "submitPaymentProof":
                return submitClaimButton({
                  isDisabled:
                    stringToTicketStatus(data.status.data) ===
                      TicketStatus.AwaitingApproval ||
                    stringToTicketStatus(data.status.data) ===
                      TicketStatus.Rejected,
                });

              default:
                return null;
            }
        }

      case TicketPhase.Management:
        switch (ticketStatus) {
          case TicketStatus.Rejected:
            switch (actionType) {
              case "editable": {
                const isDisabled =
                  stringToTicketStatus(data.status.data) !==
                  TicketStatus.Rejected;
                return editButton({ isDisabled: isDisabled });
              }
              default:
                return null;
            }
          default:
            return null;
        }

      default:
        return null;
    }
  };

  return renderActionButton();
};

DealerActionButtons.propTypes = {
  ticketPhase: PropTypes.oneOf(
    Object.values(TicketPhase).map((phase) => phase.value)
  ).isRequired,
  ticketStatus: PropTypes.oneOf(
    Object.values(TicketStatus).map((status) => status.value)
  ).isRequired,
  actions: PropTypes.shape(actionsPropType).isRequired,
  data: PropTypes.any,
  actionType: PropTypes.oneOf(["editable", "canceled", "submitPaymentProof"])
    .isRequired,
  ticketSequenceApproved: PropTypes.any,
};

export default DealerActionButtons;
